/*
 * Menu
 */

/* global biro_body */
var $biro_header_menu;


// On page load
jQuery( function ( $ ) {

	// Init
	$biro_header_menu = $( '.header-menu-wrapper' );

	// Toggle sub-menu
	$biro_header_menu.on( 'click', '.top-level-button', function ( e ) {

		// Init
		e.preventDefault();
		var $el = $( this );
		var $p  = $el.parents( '.menu-item' );

		if ( $el.attr( 'aria-expanded' ) === 'false' ) {

			// Close any open menus
			$p.siblings( '.menu-item' ).find( '.top-level-button' ).attr( 'aria-expanded', 'false' );

			// Open this one
			$el.attr( 'aria-expanded', 'true' );

			// Blur if clicking (rather than tabbing)
			if ( e.clientX > 0 ) {
				$el.blur();
			}

		} else {

			// Close this one
			$el.attr( 'aria-expanded', 'false' );

		}

	} );

	// Top-level control focus (used for styling not otherwise possible)
	$biro_header_menu.on( 'focus', '.top-level-control', function( e ) {
		$( this ).parents( '.header-menu-item' ).addClass( 'control-has-focus' );
	}).on( 'blur', '.top-level-control', function( e ) {
		$( this ).parents( '.header-menu-item' ).removeClass( 'control-has-focus' );
	});

	// Mobile toggle
	biro_body.on( 'click', '.mobile-menu-toggle', function () {

		var $el = $( this );

		if ( $el.attr( 'aria-expanded' ) === 'false' ) {

			$biro_header_menu.slideDown( 300 ).addClass( 'open' );
			$el.attr( 'aria-expanded', 'true' );

		} else {

			$biro_header_menu.slideUp( 300, function () {
				$biro_header_menu.removeClass( 'open' );
			} );
			$el.attr( 'aria-expanded', 'false' ).blur();

		}

	} );

} );
